import { render, staticRenderFns } from "./NoStockBanner.vue?vue&type=template&id=45d623d4&scoped=true"
import script from "./NoStockBanner.vue?vue&type=script&lang=js"
export * from "./NoStockBanner.vue?vue&type=script&lang=js"
import style0 from "./NoStockBanner.vue?vue&type=style&index=0&id=45d623d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d623d4",
  null
  
)

export default component.exports